import axios from "axios";

const state = {
	serverInfo: {},
	settings: {},
	acl_list: "",

	logoUrl: "/api/1/logo",
	bannerUrl: "/api/1/banner",

	hosted:false,

	errorMessage: "",
};

const actions = {
    async loadServerInfo(context){
        return axios.get("/api/1/publicinfo").then(function(response){
			if(!response.data.result.signed_in){
				window.location="/";
			}
            context.commit("setServerInfo", response.data.result)
			context.commit("setIsHosted",response.data.result)
        });
	},
	async loadPublicServerInfo(context){
        return axios.get("/api/1/publicinfo").then(function(response){
            context.commit("setServerInfo", response.data.result)
			context.commit("setIsHosted",response.data.result)
        });
	},
	async loadSettings(context){
        return axios.get("/api/1/settings").then(function(response){
			context.commit("setSettings", response.data.result)
        });
    },
	async loadACL(context){
        return axios.get("/api/1/acl").then(function(response){

            context.commit("setACL", response.data.result.access_control_list)
        });
    },

	refreshLogo(context){
		context.commit("setLogoUrl","/api/1/logo?" + new Date().getTime())
	},
	async refreshBanner(context){
		context.commit("setBannerUrl","/api/1/banner?" + new Date().getTime())
	},

	async checkHosted(context){
		return axios.get("/api/1/hosted").then(function(response){

			if(response.data.success){
				context.commit("setIsHosted",response.data.result)
			}

		});
	},

	showErrorMessage(context,message){
		context.commit("setErrorMessage",message);
	},

	clearErrorMessage(context){
		context.commit("setErrorMessage","");
	},
}

const mutations = {
	setServerInfo(state,data){
		state.serverInfo=data;
	},
	setSettings(state,data){
		state.settings = data;
	},
	setACL(state,data){
		state.acl_list = data;
	},
	setLogoUrl(state,data){
		state.logoUrl = data;
	},
	setBannerUrl(state,data){
		state.bannerUrl = data;
	},
	setIsHosted(state,data){
		state.hosted=data.hosted;
	},
	setErrorMessage(state,message){
		state.errorMessage = message;
	}
}

const getters = {
	serverInfo(state){
		return state.serverInfo;
	},
	settings(state) {
		return state.settings;
	},
	acl_list(state) {
		return state.acl_list;
	},
	logoUrl(state) {
		return state.logoUrl;
	},
	bannerUrl(state) {
		return state.bannerUrl;
	},
	hosted(state){
		return state.hosted;
	},
	isAdmin(state){

        var m = (document.cookie || "").match(/perm=(\w*)/);
        var myPermissions = m ? m[1] : "";
        var teamAdmin = myPermissions.match(/A/) ? true : false;
        return state.serverInfo.my_uid==1 || teamAdmin;
    },
	sosTitle(state){
		var result = state.serverInfo.advertised_address;
		if(result === "auto"){
			result = state.serverInfo.server_addresses[0].address
		}

		if(state.serverInfo.org_name&&state.serverInfo.org_name != ""){
			result = state.serverInfo.org_name
		}

		return result;
	},

	errorMessage(state){
		return state.errorMessage;
	}
};


export default {
    state,
    actions,
    mutations,
    getters
  };
